<template>
  <div class="fullscreen-center loading">
    <loader-vue color="black"></loader-vue>
    <div v-text="$t('generic.loading')"></div>
    <modal-no-connection-vue
      :lost-connection="!$connected"
    ></modal-no-connection-vue>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from 'vuex';
import { AUTH_ACTIONS, AUTH_MUTATIONS } from '@/store/modules/auth';
import { APP_GETTERS } from '@/store/modules/app';
import LoaderVue from '@common/Components/Loader.vue';
import ModalNoConnectionVue from '../modals/ModalNoConnection.vue';

export default {
  components: { LoaderVue, ModalNoConnectionVue },
  mounted() {
    let action = this.$authInit;

    if (this.$route.query.onlyAuth) {
      action = this.$authInitOnly;
    }

    action()
      .then(() => {
        let path = '/welcome';
        if (this.$route.query.redirect) {
          path = this.$route.query.redirect;
        }
        this.$router.replace({ path }).catch(e => {
          console.log(e);
        });
      })
      .catch(error => {
        console.log(error);

        if (error.ErrorCode === 4001) {
          this.$acceptedTos(0);
          this.$router
            .replace({
              path: '/welcome'
            })
            .catch(e => {});
        } else {
          this.$router
            .replace({
              path: '/login',
              query: { redirect: this.$route.query.redirect }
            })
            .catch(e => {});
        }
      });
  },
  methods: {
    ...mapActions('auth', {
      $authInit: AUTH_ACTIONS.$AUTHINIT,
      $authInitOnly: AUTH_ACTIONS.$AUTHINITONLY
    }),
    ...mapMutations('auth', {
      $acceptedTos: AUTH_MUTATIONS.ACCEPTED_TOS
    })
  },
  computed: {
    ...mapGetters('app', {
      $connected: APP_GETTERS.CONNECTED
    })
  }
};
</script>

<style lang="scss" scoped>
.loading {
  font-size: 1.2em;
  flex-direction: column;

  svg {
    margin-top: 10px;
  }
}
</style>
